import { IconButton } from 'modules/IconButton';
import { Falcon } from 'modules/macro';
import { useCalendar } from '../../Context';
export function CloseYearPickerButton() {
    const { yearPickerVisible, hideYearPicker } = useCalendar();
    if (!yearPickerVisible) {
        return null;
    }
    return (<IconButton appearance="ghost" type="button" onClick={hideYearPicker} size="xs">
      <Falcon icon="xmark"/>
    </IconButton>);
}
